"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllPipelines = exports.createGetAllPipelines = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _immutable = require("immutable");

var _formatPipelines = _interopRequireDefault(require("reference-resolvers/formatters/formatPipelines"));

var _formatPipelineStages = _interopRequireDefault(require("reference-resolvers/formatters/formatPipelineStages"));

var formatResponse = function formatResponse(response) {
  return (0, _immutable.Map)({
    pipelines: (0, _formatPipelines.default)(response),
    stages: (0, _formatPipelineStages.default)(response)
  });
};

var createGetAllPipelines = function createGetAllPipelines(_ref) {
  var httpClient = _ref.httpClient;
  return function () {
    return httpClient.get('deals/v1/pipelines').then(formatResponse);
  };
};

exports.createGetAllPipelines = createGetAllPipelines;
var getAllPipelines = createGetAllPipelines({
  httpClient: _apiClient.default
});
exports.getAllPipelines = getAllPipelines;